module.exports = __webpack_public_path__ + "img/mufti-half-sm.c2f875c8.jpg";